export enum StockCategory {
  expired = 'Expired',
  expiringSoon = 'Expiring Soon',
  lowStock = 'Low Stock',
  normal = 'Normal',
}
